// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3JAln","list":"BalanceDue_list__sx4q7","listRow":"BalanceDue_listRow__2yb5v","total":"BalanceDue_total__13eV-"};